import React from 'react'
import styled from 'styled-components'
import SectionTitle from './SectionTitle'
import { Row, Col } from 'react-flexbox-grid';
import {Spacer} from 'layout/util'

const FunderBlock = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-bottom: 20px;
`;

const FunderContainer = styled.div`
	display: flex;
	flex-direction: column;
	@media screen and (max-width: 767px) {
		flex-direction: column;		
	}
`;

const BigNumberContainer = styled.div`
	text-align: center;
`;

const BigNumber = styled.h1`
	color: #333;
	font-size: 72px;
	margin-bottom: 0;
`;

const BigNumberDesc = styled.h3`
	margin-top: 10px;
	font-size: 14px;
`;

const FundraisingSummary = (props) => {
	const {title, subtitle, sections} = props.data;

	const fundingSections = sections.map( (section,i) => {
		const {amountRaised, subtitle, fundersTitle, funders} = section;
	
		const funderBlurbs = funders.map ( (funder, j) => (
			<FunderBlock key={j}>
				{funder.blurb}
			</FunderBlock>
			));
		return(
			<Row key={i}>
		    <Col 
		    	xsOffset={1} xs={10} 
		      smOffset={1} sm={10} 
		      mdOffset={3} md={3} 
		      lgOffset={3} lg={3}
		    >
			    <BigNumberContainer>
				    <BigNumber>{amountRaised}</BigNumber>
				    <BigNumberDesc>
				    	{subtitle}
				    </BigNumberDesc>
			    </BigNumberContainer>
				</Col>
		    <Col 
		    	xsOffset={1} xs={10} 
		      smOffset={1} sm={10} 
		      mdOffset={0} md={3} 
		      lgOffset={0} lg={3}
		    >
		    	<Spacer height={15} />
		    	<h3>{fundersTitle}</h3>
					<FunderContainer>
						{funderBlurbs}
					</FunderContainer>
				</Col>
			</Row>
		);
	});

	return(
		<div>
			<Row>
		    <Col 
		    	xsOffset={1} xs={10} 
		      smOffset={1} sm={10} 
		      mdOffset={1} md={10} 
		      lgOffset={1} lg={10}
		    >
				<SectionTitle title={title} subtitle={subtitle} />
				</Col>
			</Row>
			{fundingSections}
		</div>
	);
}

export default FundraisingSummary;


// WEBPACK FOOTER //
// ./src/pages/june-5/races/components/FundraisingSummary.js